document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const opened = document.querySelectorAll('.bhd-nav[open], .bhd-nav details[open]');
  for (const details of opened) {
    details.open = false;
    details.querySelector('summary')?.focus();
  }
});
document.addEventListener('click', (event) => {
  for (const details of document.querySelectorAll('.bhd-nav[open], .bhd-nav details[open]')) {
    if (!details.contains(event.target)) details.open = false;
  }
});
